"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HMSMediaStreamConstraints = void 0;
const events_1 = require("events");
const protoo_client_1 = require("protoo-client");
const stream_1 = require("./stream");
const uuid_1 = require("uuid");
const log = require("loglevel");
const error_1 = require("./error");
const startPing = (peer, pingInterval) => {
    return new Promise((resolve, reject) => {
        function ping() {
            // @ts-ignore
            if (!peer._connected)
                return;
            const pingTime = Date.now();
            let pongTime = Infinity;
            peer
                .request('ping', { time: pingTime })
                .then(() => {
                pongTime = Date.now();
            })
                .catch(() => {
                pongTime = Date.now();
            });
            setTimeout(() => {
                if (pongTime !== Infinity) {
                    ping();
                }
                else {
                    reject(`[Ping Service] Pong not received within ${pingInterval} seconds`);
                }
            }, pingInterval);
        }
        ping();
    });
};
class HMSMediaStreamConstraints {
    constructor(config) {
        this.shouldPublishAudio = false;
        this.shouldPublishVideo = false;
        this.bitrate = 512;
        this.codec = '';
        this.shouldPublishAudio = config.shouldPublishAudio;
        this.shouldPublishVideo = config.shouldPublishVideo;
        this.codec = config.codec;
        this.bitrate = config.bitrate;
        this.frameRate = config.frameRate;
        this.resolution = config.resolution;
        this.advancedMediaConstraints = config.advancedMediaConstraints;
    }
}
exports.HMSMediaStreamConstraints = HMSMediaStreamConstraints;
class HMSClient extends events_1.EventEmitter {
    constructor(peer, config) {
        super();
        this.onRequest = (request) => {
            log.debug('Request from SFU: [method:%s, data:%s]', request.method, JSON.stringify(request.data, null, 2));
        };
        this.onNotification = (notification) => {
            const { method, data } = notification;
            log.debug('Notification from SFU: [method:%s, data:%s]', method, JSON.stringify(data, null, 2));
            switch (method) {
                case 'peer-join': {
                    const room = data.rid;
                    const peer = {
                        uid: data.uid,
                        name: data.info.name,
                    };
                    this.emit('peer-join', room, peer);
                    break;
                }
                case 'peer-leave': {
                    const room = data.rid;
                    const peer = {
                        uid: data.uid,
                        name: data.info.name,
                    };
                    this.emit('peer-leave', room, peer);
                    break;
                }
                case 'stream-add': {
                    const { mid, info, tracks } = data;
                    if (mid) {
                        const trackMap = objToStrMap(tracks);
                        this.knownStreams.set(mid, trackMap);
                    }
                    const room = data.rid;
                    // @TODO: peer needs to an instance of HMSPeer
                    const peer = {
                        uid: data.uid,
                        peerId: data.uid,
                        name: data.info.name,
                        role: data.info.role,
                        customerUserId: data.info.user_id,
                    };
                    // @TODO: Need to create a new interface for streamInfo (ref iOS)
                    const streamInfo = {
                        mid: data.mid,
                        tracks: data.tracks,
                        description: String(data.description),
                        screen: Boolean(data.screen),
                    };
                    this.emit('stream-add', room, peer, streamInfo);
                    break;
                }
                case 'stream-remove': {
                    const { mid } = data;
                    const stream = this.streams[mid];
                    stream.close();
                    const room = data.rid;
                    const streamInfo = {
                        mid: data.mid,
                    };
                    const peer = {
                        uid: data.uid,
                        peerId: data.uid,
                        name: data.info.name,
                        role: data.info.role,
                        customerUserId: data.info.user_id,
                    };
                    this.emit('stream-remove', room, peer, streamInfo);
                    break;
                }
                case 'broadcast': {
                    const room = data.rid;
                    const peer = {
                        uid: data.uid,
                        name: data.info.senderName,
                    };
                    const message = data.info.msg;
                    this.emit('broadcast', room, peer, message);
                    break;
                }
            }
        };
        this.peer = peer;
        this.config = config;
        const uid = uuid_1.v4();
        this.uid = uid;
        this.knownStreams = new Map();
        this.streams = {};
        log.setLevel(log.levels.DEBUG);
        log.debug('Created a new HMSClient instance');
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.peer) {
                throw new error_1.default('GenericConnect: HMSPeer is needed');
            }
            if (!this.config) {
                throw new error_1.default('GenericConnect: HMSClientConfig is needed');
            }
            const parsedToken = JSON.parse(atob(this.peer.authToken.split('.')[1]));
            const room_id = parsedToken.room_id;
            const url = new URL('/ws', this.config.endpoint);
            url.searchParams.set('peer', this.uid);
            url.searchParams.set('token', this.peer.authToken);
            url.searchParams.set('room_id', room_id);
            log.info('Connecting to SFU');
            const transport = new protoo_client_1.WebSocketTransport(url.toString());
            this.dispatch = new protoo_client_1.Peer(transport);
            stream_1.Stream.setDispatch(this.dispatch);
            this.dispatch.on('open', () => {
                log.info('Connected to SFU');
                this.emit('connect');
                log.debug('Starting ping service');
                const pingInterval = 10;
                startPing(this.dispatch, pingInterval * 1000).catch((error) => {
                    log.debug(error);
                    log.debug('Emitting disconnected event because ping failed');
                    this.emit('disconnected');
                });
            });
            this.dispatch.on('close', () => {
                log.info('Disconnected from SFU');
                log.debug('Emitting disconnect event');
                this.emit('disconnect');
            });
            this.dispatch.on('request', this.onRequest);
            this.dispatch.on('notification', this.onNotification);
            this.dispatch.on('failed', (currentAttempt) => {
                log.info(`Unable to reach SFU, retrying - attempt:${currentAttempt}`);
                log.debug('Emitting failed event');
                this.emit('failed');
            });
            this.dispatch.on('disconnected', () => {
                log.info(`SFU disconnected`);
                log.debug('Emitting disconnected event because SFU was unreachable');
                this.emit('disconnected');
            });
        });
    }
    join(room) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug(`Joining room ${room}`);
            try {
                yield this.dispatch.request('join', {
                    rid: room,
                    uid: this.uid,
                    info: { name: this.peer.userName },
                });
                // @TODO This shouldn't be needed
                this.rid = room;
                log.info(`Joined room ${room}`);
            }
            catch (error) {
                log.error('Unable to join room' + error);
                throw error;
            }
        });
    }
    getLocalStream(constraints, unsafeOptions) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const audioConstraints = ((_a = constraints.advancedMediaConstraints) === null || _a === void 0 ? void 0 : _a.audio) || constraints.shouldPublishAudio;
            let videoConstraints = constraints.shouldPublishVideo || {
                frameRate: { max: constraints.frameRate || 20 },
            };
            if (((_b = constraints.advancedMediaConstraints) === null || _b === void 0 ? void 0 : _b.video) instanceof Object) {
                videoConstraints = Object.assign({ frameRate: { max: constraints.frameRate } }, (_c = constraints.advancedMediaConstraints) === null || _c === void 0 ? void 0 : _c.video);
            }
            const options = {
                codec: constraints.codec,
                resolution: constraints.resolution,
                audio: audioConstraints,
                video: videoConstraints,
                bandwidth: constraints.bitrate,
            };
            log.debug(`Getting localStream with options ${JSON.stringify(options, null, 2)}`);
            // @NOTE: We might deprecate this anytime in future
            options.screen = Boolean(unsafeOptions && unsafeOptions.screen);
            if (unsafeOptions && unsafeOptions.description) {
                options.description = unsafeOptions.description;
            }
            return stream_1.LocalStream.getUserMedia(options);
        });
    }
    getLocalScreen(constraints, unsafeOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                codec: constraints.codec,
                resolution: constraints.resolution,
                video: { frameRate: { max: constraints.frameRate || 10 } },
                bandwidth: constraints.bitrate,
            };
            log.debug(`Getting localScreen with options ${JSON.stringify(options, null, 2)}`);
            if (unsafeOptions && unsafeOptions.description) {
                options.description = unsafeOptions.description;
            }
            const screen = stream_1.LocalStream.getDisplayMedia(options);
            return screen;
        });
    }
    publish(stream, room) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!room) {
                throw new error_1.default('NothingToReturn: You must join a room before publishing.');
            }
            if (!stream) {
                throw new error_1.default('NothingToReturn: stream is null');
            }
            if (!stream.options.screen) {
                this.local = stream;
            }
            log.debug(`Publishing stream`, JSON.stringify(stream, null, 2));
            const localStream = yield stream.publish(room).catch((error) => {
                log.error(`Error publishing local stream`, error, JSON.stringify(stream, null, 2));
                throw error;
            });
            log.debug(`Published stream`, JSON.stringify(localStream, null, 2));
            // @ts-ignore
            (_a = stream.transport.pc) === null || _a === void 0 ? void 0 : _a.onconnectionstatechange = () => {
                var _a;
                log.debug(
                // @ts-ignore
                `IceConnectionState: ${(_a = stream.transport.pc) === null || _a === void 0 ? void 0 : _a.connectionState}`);
                // @ts-ignore
                if (stream.transport.pc.connectionState === 'failed') {
                    log.debug('Emitting disconnected event because IceConnection failed');
                    this.emit('disconnected');
                }
            };
            // @ts-ignore
            (_b = stream.transport.pc) === null || _b === void 0 ? void 0 : _b.onicecandidateerror = (e) => {
                log.debug(`Icecandidate error`);
                log.error('error: ', e);
            };
            return localStream;
        });
    }
    subscribe(mid, room) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!room) {
                throw new error_1.default('NothingToReturn: You must join a room before subscribing.');
            }
            const tracks = this.knownStreams.get(mid);
            if (!tracks) {
                throw new error_1.default('NothingToReturn: Subscribe mid is not known.');
            }
            const remoteStream = yield stream_1.RemoteStream.getRemoteMedia(room, mid, tracks).catch((error) => {
                log.error(`Error in subscribing to ${mid}`);
                throw error;
            });
            log.debug('subscribed to remote stream', mid, JSON.stringify(remoteStream, null, 2));
            this.streams[mid] = remoteStream;
            return remoteStream;
        });
    }
    broadcast(info, room) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug('Broadcasting message to %s:', room, JSON.stringify(info, null, 2));
            return this.dispatch.request('broadcast', {
                rid: room,
                uid: this.uid,
                info,
            });
        });
    }
    unpublish(stream, room) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug('Unpublishing stream', JSON.stringify(stream, null, 2));
            return stream.unpublish();
        });
    }
    unsubscribe(stream, room) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug('Unsubscribing from stream', JSON.stringify(stream, null, 2));
            return stream.unsubscribe();
        });
    }
    disconnect() {
        log.debug('Disconnecting from SFU');
        this.dispatch.close();
    }
    applyConstraints(options, stream) {
        var _a, _b, _c, _d, _e;
        log.debug('Applying constraints', JSON.stringify(options, null, 2));
        // @TODO: Need to test this for cases where the call started without audio/video track
        const audioTrack = stream.getAudioTracks()[0];
        const videoTrack = stream.getVideoTracks()[0];
        const audioSettings = audioTrack.getSettings();
        const videoSettings = videoTrack.getSettings();
        const transport = stream.transport;
        let audioConstraints = null;
        let videoConstraints = null;
        // Handle Audio
        if (options.shouldPublishAudio === false) {
            audioTrack.enabled = false;
        }
        else {
            if (((_a = options.advancedMediaConstraints) === null || _a === void 0 ? void 0 : _a.audio) instanceof Object) {
                audioConstraints = Object.assign(Object.assign({}, audioSettings), (_b = options.advancedMediaConstraints) === null || _b === void 0 ? void 0 : _b.audio);
            }
        }
        // Handle Video
        if (options.shouldPublishVideo === false) {
            videoTrack.enabled = false;
        }
        else {
            if (((_c = options.advancedMediaConstraints) === null || _c === void 0 ? void 0 : _c.video) instanceof Object) {
                videoConstraints = Object.assign(Object.assign({}, videoSettings), (_d = options.advancedMediaConstraints) === null || _d === void 0 ? void 0 : _d.video);
            }
            if (options.bitrate) {
                // @TODO: Need to refactor and clean this up without resorting to using ts-ignore
                // @ts-ignore
                (_e = transport === null || transport === void 0 ? void 0 : transport.pc) === null || _e === void 0 ? void 0 : _e.createOffer().then((offer) => transport.pc.setLocalDescription(offer)).then(() => {
                    const desc = {
                        // @ts-ignore
                        type: transport.pc.remoteDescription.type,
                        // @ts-ignore
                        sdp: stream_1.getMungedSdp(transport.pc.remoteDescription.sdp, 'video', options.bitrate),
                    };
                    // @ts-ignore
                    return transport.pc.setRemoteDescription(desc);
                }).then(() => {
                    if (!videoTrack.enabled) {
                        videoTrack.enabled = true;
                    }
                });
            }
            if (options.frameRate) {
                if (videoConstraints) {
                    videoConstraints = Object.assign(Object.assign({}, videoConstraints), { frameRate: { max: options.frameRate } });
                }
                else {
                    videoConstraints = Object.assign(Object.assign({}, videoSettings), { frameRate: { max: options.frameRate } });
                }
            }
            if (options.resolution) {
                if (videoConstraints) {
                    videoConstraints = Object.assign(Object.assign({}, videoConstraints), stream_1.VideoResolutions[options.resolution]);
                }
                else {
                    videoConstraints = Object.assign(Object.assign({}, videoSettings), stream_1.VideoResolutions[options.resolution]);
                }
            }
        }
        if (audioConstraints) {
            audioTrack.applyConstraints(audioConstraints).then(() => {
                log.debug('Applied audio constraints: ', JSON.stringify(audioTrack.getConstraints(), null, 2));
            });
            if (audioConstraints.deviceId && audioConstraints.deviceId !== audioSettings.deviceId) {
                // @ts-ignore
                stream.switchDevice('audio', audioConstraints.deviceId);
            }
        }
        if (videoConstraints) {
            videoTrack.applyConstraints(videoConstraints).then(() => {
                log.debug('Applied video constraints: ', JSON.stringify(videoTrack.getConstraints(), null, 2));
            });
            if (videoConstraints.deviceId && videoConstraints.deviceId !== videoSettings.deviceId) {
                // @ts-ignore
                stream.switchDevice('video', videoConstraints.deviceId);
            }
        }
    }
}
exports.default = HMSClient;
function objToStrMap(obj) {
    const strMap = new Map();
    for (const k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
    }
    return strMap;
}
